import React from "react";
export var prepRoute = function (View) { return ({
    match: function (type) {
        return type === "HomePage";
    },
    page: function (_a) {
        var data = _a.data;
        return React.createElement(View, { homepage: data });
    },
}); };
